import React, { useMemo } from 'react';
import AppPillStatus from '../CreditApplicationsMonitor/AppPillStatus';
import {
  CheckCircle,
  ClockAfternoon,
  File,
  Info,
  Minus,
  TrendDown,
  TrendUp,
  Warning,
  WarningCircle,
} from 'phosphor-react';
import { twMerge } from 'tailwind-merge';

interface CreditMonitorTileProps {
  title: string;
  subTitle: string;
  details?: string;
  status: 'SUCCESS' | 'DISABLED' | 'ERROR' | 'INFO' | 'WARNING';
  riskLabel: string;
  type:
    | 'trend-down'
    | 'trend-up'
    | 'trend-none'
    | 'file'
    | 'warning'
    | 'error'
    | 'info'
    | 'success'
    | 'disabled';
}

const CreditMonitorTile: React.FC<CreditMonitorTileProps> = ({
  title,
  subTitle,
  details,
  status,
  riskLabel,
  type,
}) => {
  const labelClassName = useMemo(() => {
    switch (status) {
      case 'SUCCESS':
        return 'SUCCESS_100-BG SUCCESS_500-CLR';
      case 'DISABLED':
        return 'GREY_100-BG GREY_500-CLR';
      case 'ERROR':
        return 'ERROR_100-BG ERROR_500-CLR';
      case 'INFO':
        return 'INFO_100-BG INFO_500-CLR';
      case 'WARNING':
        return 'WARNING_100-BG WARNING_500-CLR';
      default:
        return '';
    }
  }, [status]);
  return (
    <div className="w-full border p-2 flex rounded-lg justify-between">
      <div className="flex gap-2">
        <div
          className={twMerge(
            `rounded-full h-8 w-8 text-xs flex justify-center items-center`,
            labelClassName
          )}>
          {type === 'trend-down' && <TrendDown size={16} weight="bold" />}
          {type === 'trend-up' && <TrendUp size={16} weight="bold" />}
          {type === 'trend-none' && <Minus size={16} weight="bold" />}
          {type === 'file' && <File size={16} weight="fill" />}
          {type === 'success' && <CheckCircle size={16} weight="fill" />}
          {type === 'error' && <Warning size={16} weight="bold" />}
          {type === 'info' && <Info size={16} weight="bold" />}
          {type === 'warning' && <WarningCircle size={16} weight="bold" />}
          {type === 'disabled' && <ClockAfternoon size={16} weight="bold" />}
        </div>
        <div>
          <div className="font-semibold text-sm mb-0.5">{title}</div>
          <div className="text-xs GREY_500-CLR mb-1">{subTitle}</div>
          {details && <div className="text-xs GREY_500-CLR">{details}</div>}
        </div>
      </div>
      <AppPillStatus status={status} label={riskLabel} wrapperClassName="w-fit" />
    </div>
  );
};

export default CreditMonitorTile;
